export default "__VITE_ASSET__d9be723e__"